import { filter, map, tap } from 'rxjs';
// import { CreativesAPI } from '#/services/creatives-api.js';
import * as actions from '#/store/actions/actions.js';
import setupStoreListeners from '#/store/listeners.js';
import { setExtensionAllowed } from '#/store/slices/extensions/actions.js';
import scopeLogger from '#/lib/scope-logger.js';

const console = scopeLogger('RMI:connectGateways');
const INTERNAL_ERRORS = ({ topic, payload }) =>
  topic === 'internal' && payload.type === 'error';

export default function connectGateways({
  hostGateway,
  mns,
  store,
  configProvider,
}) {
  mns.message$.pipe(filter(INTERNAL_ERRORS)).subscribe((message) => {
    if (message.payload.code === 401) {
      hostGateway.requestNewToken();
    } else if (message.payload.code === 999) {
      // panic
      hostGateway.sendNotify.error({
        fatal: true,
        message: message.payload.message,
      });
    }
  });

  hostGateway.message$
    .pipe(filter(({ event_type }) => event_type === 'change_token'))
    .subscribe(({ new_token }) => {
      configProvider.patchConfig('token', new_token);
    });

  mns.onConnectionChange = (isConnected) => {
    store.dispatch(actions.mnsConnectionStateChange({ isConnected }));
  };

  {
    const mapCmdToAction = new Map([
      ['start', actions.interactiveStart],
      ['pause', actions.interactivePause],
      ['resume', actions.interactiveResume],
      ['zone-resize', actions.interactiveResize],
      ['settings_changed', setExtensionAllowed],
    ]);

    /*
TODO: Disable that action when all time related changes migrated to components
  e.g. emoji.displayQueue, extending every other actions with current time, etc.
  Also: replace store listener updateTimer action
  Also: move 01-app middleware logic into timeService
 */
    hostGateway.position$
      .pipe(map(actions.updateTimer))
      .subscribe(store.dispatch);

    const pipeline = [
      filter((message) => mapCmdToAction.has(message.cmd)),
      map((message) => mapCmdToAction.get(message.cmd)(message.payload)),
    ];

    if (import.meta.env.DEV) {
      pipeline.push(
        tap((action) => {
          console.log('Mapping message to redux action', action);
        }),
      );
    }
    hostGateway.message$.pipe(...pipeline).subscribe(store.dispatch);
  }

  configProvider.subscribe((config) => {
    store.dispatch(actions.interactiveCreate(config));
  });

  setupStoreListeners(store, { hostGateway });
}
